import { render, staticRenderFns } from "./LaboratoryOrderInfo.vue?vue&type=template&id=35747438&scoped=true"
import script from "./LaboratoryOrderInfo.vue?vue&type=script&lang=js"
export * from "./LaboratoryOrderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35747438",
  null
  
)

export default component.exports